import { Button, Link, Text } from '@acast/decibel';
import config from 'app/config';
import T from 'prop-types';
import React from 'react';
import appleLogo from 'server/services/web/public/images/distribution-logo-podcast.svg';
import Distribution from './distribution';

const getRssUrl = show => {
  const showUrl = show ? show.permalinks[0] : null;
  const rssHost = config.get('RSS_HOST', 'https://rss.acast.com');
  return showUrl ? `${rssHost}/${showUrl}` : '';
};

const AppleDistribution = props => {
  return (
    <Distribution
      title="Apple Podcasts"
      logo={appleLogo}
      button={
        <Button
          data-test-id="AppleDistribution__button"
          onClick={() =>
            window.open(
              `https://podcastsconnect.apple.com/my-podcasts/new-feed?submitfeed=${getRssUrl(
                props.show
              )}`,
              '_blank',
              'noopener'
            )
          }
          variant="secondary"
          size="small"
          busy={false}
        >
          Submit
        </Button>
      }
      logoAlt="Apple Podcasts Logo"
    >
      <Text variant="body2">
        If your show is not yet on Apple Podcasts, submit it now. If you are already on Apple
        Podcasts there is no need to resubmit.
      </Text>
      <Text variant="body2">
        Clicking ‘Submit’ will redirect to Apple's Podcasts Connect - you will need to log in using
        an Apple ID.
      </Text>
      <Text variant="body2">
        Status of your submission will be managed within Podcasts Connect. Apple can take 3-5
        business days to approve your feed.
      </Text>
      <Text variant="body2">
        How to set up an Apple ID:{' '}
        <Link
          href="https://support.apple.com/en-us/HT204316"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://support.apple.com/en-us/HT204316
        </Link>
      </Text>
    </Distribution>
  );
};

AppleDistribution.propTypes = {
  show: T.object.isRequired,
};

export default AppleDistribution;
